import { TUpdateTemplateFavoriteParams, AddUserTemplateFavorite } from '@/connection/templates';
import toastTrigger from '@ui/toast/toast-trigger';
import { TemplatesReducerCreator } from '../types';
import { serializeError } from '@/store/utils/serialize-error';

const addUserTemplateFavoriteReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async ({ activeChannel, adminId, projectUuid }: TUpdateTemplateFavoriteParams, { rejectWithValue }) => {
      try {
        return AddUserTemplateFavorite({ activeChannel, adminId, projectUuid });
      } catch (error) {
        console.error(error);
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.userFavorites = state.userFavorites || [];
          state.userFavorites.push(action.payload);
        }
      },
      rejected: (_, action) => {
        console.error(action.error);
        toastTrigger('Failed to update favorites. Please refresh and try again.', {
          type: 'error',
        });
      },
    }
  );
};

export default addUserTemplateFavoriteReducer;
